import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory, useLocation } from 'react-router-dom';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { LikeLink } from '../AcademyLinks';
import styled from 'styled-components';
import { OLAF, CALYPSO_MEDIUM } from 'HubStyleTokens/colors';
import { removeTrailingSlash } from '../../utils/RoutingUtils';
const AwardLink = styled(LikeLink).withConfig({
  displayName: "TrackViewAwardLink__AwardLink",
  componentId: "tabel7-0"
})(["color:", ";text-decoration:underline;:hover{color:", ";}"], OLAF, CALYPSO_MEDIUM);
export const TrackViewAwardLinkComponent = ({
  award,
  certification,
  className,
  trackId,
  size = 'default',
  useCurrentText,
  block,
  useButton = true,
  use = useButton ? 'primary' : 'dark',
  expired,
  likeLink
}) => {
  const history = useHistory();
  const {
    pathname,
    search
  } = useLocation();
  if (!award) return null;
  const awardName = award.awardName;
  const noTrailingUrl = removeTrailingSlash(pathname);
  const link = `${noTrailingUrl}/award/${trackId}/${awardName}${search}`;
  let label = 'learningCenter.common.viewCertificateOfCompletion';

  if (certification) {
    label = useCurrentText ? 'learningCenter.common.viewCurrentCertification' : 'learningCenter.common.viewCertification';
  }

  if (expired) {
    label = 'learningCenter.common.viewExpiredCertification';
  }

  if (likeLink) return /*#__PURE__*/_jsx(AwardLink, {
    onClick: e => {
      e.preventDefault();
      history.push(link);
    },
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: label
    })
  });
  const UIButtonOrLink = useButton ? UIRouterButton : UIRouterLink;
  return /*#__PURE__*/_jsx(UIButtonOrLink, {
    block: block,
    className: className,
    "data-test-id": "view-award-button",
    size: size,
    to: link,
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: label
    })
  });
};
export default TrackViewAwardLinkComponent;